import MainLayout from './mainLayout.vue'

export default MainLayout
